import React from 'react';
import { CheckIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { includedList, valueStack } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Offer() {
  return <section className="w-full bg-sand px-4 py-14 sm:px-6 sm:py-20" data-id="element-222" data-mp="356vmsephzuwf">
      <div className="mx-auto max-w-2xl" data-id="element-223" data-mp="353zouqdnh67z">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-224" data-mp="3a68fvh6ypy7g">
          Tutto ciò che ricevi oggi
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-225" data-mp="3f271ix0wp246">
          Il valore completo del Sistema
        </h2>
        <p className="mt-3 text-center text-[15px] font-semibold text-navy/70" data-id="element-226" data-mp="3nvk5qv4f7q5k">
          €414 di risorse cliniche. Oggi, solo €19.
        </p>

        <ul className="mt-8 grid gap-2 sm:grid-cols-2" data-id="element-227" data-mp="1pn7a1i8t74v">
          {includedList.map(item => <li key={item} className="flex items-start gap-2 rounded-xl bg-white px-3.5 py-3 text-[13.5px] font-semibold leading-snug text-navy" data-id="element-228" data-mp="1klgnmqidson1">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-229" data-mp="1foq7k36ktt1m" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy/10 bg-white" data-id="element-230" data-mp="16mqm8yoj42sv">
          {valueStack.map(row => <div key={row.title} className="border-b border-navy/10 p-4 last:border-b-0 sm:p-5" data-id="element-231" data-mp="23e2dmu6lxkzp">
              <div className="flex items-start justify-between gap-3" data-id="element-232" data-mp="1zb5yjdga070i">
                <h3 className="font-display text-[16px] font-bold leading-snug text-navy sm:text-[17px]" data-id="element-233" data-mp="1uicwixc6zcs4">
                  {row.title}
                </h3>
                <span className="shrink-0 font-display text-[16px] font-bold text-navy/40 line-through" data-id="element-234" data-mp="2mzoxv3hcl9gg">
                  {row.price}
                </span>
              </div>
              <p className="mt-1.5 text-[13.5px] leading-relaxed text-navy/60" data-id="element-235" data-mp="2i75nsghvcwge">{row.body}</p>
            </div>)}
          <div className="flex items-center justify-between gap-3 bg-navy/[0.04] px-4 py-4 sm:px-5" data-id="element-236" data-mp="364al4700toyf">
            <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-navy/60" data-id="element-237" data-mp="2sdf6ee2ucdmx">Valore totale</span>
            <span className="font-display text-xl font-bold text-navy line-through" data-id="element-238" data-mp="2wdz5hn6z5rbp">€414</span>
          </div>
        </div>

        <div className="mt-6 rounded-3xl bg-navy p-6 text-center sm:p-8" data-id="element-239" data-mp="2ie7s9ooa8eyr">
          <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-white/60" data-id="element-240" data-mp="2necc9ooefrtq">
            Oggi puoi ottenere il Sistema Completo per
          </p>
          <p className="mt-2 font-display text-[64px] font-bold leading-none text-white sm:text-[76px]" data-id="element-241" data-mp="29gnpgbaruam1">€19</p>
          <p className="mt-3 text-[13px] font-medium text-white/70" data-id="element-242" data-mp="7n7p2movthdv">
            Pagamento una tantum · Accesso digitale a vita · Download immediato
          </p>

          <div className="mt-6" data-id="element-243" data-mp="bnqiumac4xip">
            <CtaBlock label="Sì — voglio il Sistema Maestro" tone="dark" note="Ottieni l’accesso immediato per €19" data-id="element-244" data-mp="1w6aty80fr4sq" />
          </div>

          <div className="mt-6" data-id="element-245" data-mp="1s60bhvvgilwz">
            <Countdown tone="dark" data-id="element-246" data-mp="1s2w0ofnhkrxc" />
          </div>

          <p className="mt-5 flex items-center justify-center gap-1.5 text-[12.5px] font-medium text-white/70" data-id="element-247" data-mp="25wna7o17wbt2">
            <GlobeIcon className="h-3.5 w-3.5 text-white/50" aria-hidden="true" data-id="element-248" data-mp="214m0o9vfoz6q" />
            Cambio di valuta automatico: paghi nella tua valuta locale.
          </p>

          <div className="mt-5" data-id="element-249" data-mp="2avqfn9l40k1k">
            <ScarcityBar tone="dark" data-id="element-250" data-mp="2auota8yn8b4j" />
          </div>

          <p className="mt-4 flex items-center justify-center gap-1.5 text-[12px] font-semibold text-white/60" data-id="element-251" data-mp="2ov9grifi6v4d">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-252" data-mp="2jvn172c7d2se" />
            Pagamento sicuro · Garanzia di rimborso di 7 giorni
          </p>
        </div>
      </div>
    </section>;
}